// src/pages/DashboardPage.tsx
import { useTranslation } from "react-i18next";
import PageHeader from "components/Common/PageHeader";
import NoDataComponent from "components/Common/NoData";

const DashboardPage = () => {
  const { t } = useTranslation();

  const breadcrumbItems = [
    { label: "dashboard", active: true },
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader title={t("dashboard")} breadcrumbItems={breadcrumbItems} />
      
        <NoDataComponent />
      </div>
      
    </div>
  );
};

export default DashboardPage;
